/**
 * Web Style Import
 *
 */

import './style/dnb-logo.scss'
import './style/sbanken-logo.scss'
